import "./pendingBooks.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect } from "react";
import LibraryList from "../../components/libraryList/libraryList";

const PendingBooks = () => {
  useEffect(() => {
    document.title = "Wishallbook >> Pending Books";
  }, []);

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <LibraryList type="pending"/>
      </div>
    </div>
  );
};

export default PendingBooks;